import React, { useContext, useEffect, useState } from 'react';
import '../../../assets/css/admin/dashboard/adminfaqs/managefaqs.css';
import AdminMasterLayout from 'layouts/AdminMasterLayout';
import axios from 'axios';
import AppContext from 'context/AppContext';
import { Spinner } from 'react-bootstrap';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import Swal from 'sweetalert2';


const CATEGORIES = ['Listings', 'Support', 'General', 'Buying Tips', 'Market Trends'];
const ITEMS_PER_PAGE = 4;

// ─── Success Popup ─────────────────────────────────────────────────────────────
const SuccessPopup = ({ show, onClose }) => {
  if (!show) return null;
  return (
    <div className="faq-success-overlay" onClick={onClose}>
      <div className="faq-success-popup" onClick={e => e.stopPropagation()}>
        <div className="faq-success-icon-wrap">
          <div className="faq-ring faq-ring1" />
          <div className="faq-ring faq-ring2" />
          <div className="faq-ring faq-ring3" />
          <div className="faq-checkmark">
            <svg viewBox="0 0 52 52" fill="none">
              <circle cx="26" cy="26" r="25" stroke="#000" strokeWidth="2" />
              <path className="faq-check-path" d="M14 27l8 8 16-16"
                stroke="#000" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
        <h4 className="faq-success-title">Congratulations!</h4>
        <p className="faq-success-msg">Your FAQ has been saved successfully.</p>
        <button className="faq-success-btn" onClick={onClose}>Done</button>
      </div>
    </div>
  );
};

// ─── Add Question Modal ────────────────────────────────────────────────────────
const AddQuestionModal = ({ show, onClose, onSuccess, loadAllFaqs, textForEditAdd, faqForEdit, setShowModal }) => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [category, setCategory] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(true);

  // if (!show) return null;
  const createFaqs = () => {
    if (
      question.trim() === "" ||
      answer.trim() === "" ||
      category.trim() === ""
    ) {

      Swal.fire({
        title: 'Missing Fields!',
        text: 'Please fill all fields',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;

    }
    console.log(authToken);
    setLoading(true);
    const formData = new FormData();
    formData.append("question", question)
    formData.append("answer", answer)
    formData.append("category", category)
    formData.append("status", status)

    axios.post(`${baseUrl}/admin/faq/createFaqs`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        }
      })
      .then((response) => {
        console.log("resposne called", response.data);
        if (response.data.success) {
          Swal.fire({
            title: 'Congratulations!',
            text: 'Your FAQ has been saved successfully.',
            icon: 'success',
            confirmButtonText: 'Awesome!'
          });
          onClose();
          loadAllFaqs();
          resetForm();
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);

      })

  };

  const editFaq = () => {
    setLoading(true);
    console.log(authToken);
    const formData = new FormData();
    formData.append("id", faqForEdit.id)
    formData.append("question", question)
    formData.append("answer", answer)
    formData.append("category", category)
    formData.append("status", status)

    axios.post(`${baseUrl}/admin/faq/updateFaqs`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        }
      })
      .then((response) => {
        console.log("resposne called", response.data);

        if (response.data.success) {
          onClose();
          loadAllFaqs();
          resetForm();
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
  }
  const resetForm = () => {
    setQuestion("");
    setAnswer("");
    setCategory("");
    setStatus(true);
  };


  useEffect(() => {
    console.log("this is log from the add modal", faqForEdit);
    if (textForEditAdd == "Edit") {
      setQuestion(faqForEdit.question)
      setAnswer(faqForEdit.answer)
      setCategory(faqForEdit.category)
      setStatus(faqForEdit.status)
    }
  }, [show]);

  return (
    show ?
      <div className="faq-modal-overlay" onClick={onClose}>
        <div className="faq-modal-container" onClick={e => e.stopPropagation()}>
          {/* Header */}
          <div className="faq-modal-header">
            <h2 className="faq-modal-title">{textForEditAdd} Question</h2>
            <button className="faq-close-btn" onClick={onClose}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* Form */}
          <form className="faq-modal-form">
            <div className="faq-form-group">
              <label className="faq-form-label">Question:</label>
              <input
                type="text"
                name="question"
                value={question}
                // value={textForEditAdd == "Edit" ? faqForEdit.question : question}
                onChange={(e) => setQuestion(e.target.value)}
                className="faq-form-input"
                placeholder="How to verify my account?"
                required
              />
            </div>

            <div className="faq-form-group">
              <label className="faq-form-label">Answer:</label>
              <textarea
                name="answer"
                value={answer}
                // value={textForEditAdd == "Edit" ? faqForEdit.answer : answer}
                onChange={(e) => setAnswer(e.target.value)}
                className="faq-form-input faq-form-textarea"
                rows={3}
              />
            </div>

            <div className="faq-form-group">
              <label className="faq-form-label">Category:</label>
              <select
                name="category"
                value={category}
                // value={textForEditAdd == "Edit" ? faqForEdit.category : category}
                onChange={(e) => setCategory(e.target.value)}
                className="faq-form-input faq-form-select"
              >
                <option value="">Select Category</option>
                {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div className="faq-form-group faq-status-row">
              <span className="faq-form-label">Status:</span>
              <div className="faq-toggle-wrap">
                <div
                  className={`faq-toggle ${status ? 'faq-toggle-on' : ''}`}

                  onChange={(e) => setStatus(e.target.value)}
                >
                  <div className="faq-toggle-knob" />
                </div>
                <span className="faq-toggle-text">{status ? 'Active' : 'Inactive'}</span>
              </div>
            </div>

            <div className="faq-form-actions">
              <button type="button" className=" faq-save-btn"
                disabled={loading}
                onClick={textForEditAdd == "Edit" ? editFaq : createFaqs}>
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Saving...
                  </>
                ) : (
                  'Save'
                )}
              </button>
              <button type="button" className="faq-cancel-btn"
                onClick={() => {
                  resetForm();
                  onClose();
                }}
              >
                Cancel</button>
            </div>
          </form>
        </div>
      </div>
      : null
  );
};

// ─── Main Component ────────────────────────────────────────────────────────────
const Managefaqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [textForEditAdd, setTextForEditAdd] = useState("Add");
  const [faqForEdit, setFaqForEdit] = useState(null);
  const { baseUrl,authToken} = useContext(AppContext);


  const totalPages = Math.ceil(faqs.length / ITEMS_PER_PAGE);
  const paginated = faqs.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  const viewAllFaqs = () => {
    axios
      .get(`${baseUrl}/admin/faq/viewAllFaqs`,{
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        }
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setFaqs(response.data.exfaq || []);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const deleteFaqs = (faq) => {
    console.log("**********",);
    const formdata = new FormData();
    formdata.append("id", faq.id);
    axios.post(`${baseUrl}/admin/faq/deleteFaqs`, formdata,{
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        }
      })
      .then((response) => {
        console.log(response.data);
        viewAllFaqs();
      })
      .catch((error) => console.log(error));
  };

  const handleEditFaq = () => {
    setTextForEditAdd("Edit");
    setShowModal(true);
  }

  useEffect(() => {
    setLoading(true);
    viewAllFaqs();
  }, []);

  return (
    <AdminMasterLayout pageTitle='FAQs Management'>
      <div className="faq-page">
        {/* ── Page Header ── */}
        <div className="faq-page-header">
          {/* <h2 className="faq-page-title">FAQs Management</h2> */}
          <button className="faq-add-btn" onClick={() => {
            setShowModal(true);
            setTextForEditAdd("Add");
          }}>
            <span className="faq-add-icon">+</span> Add Question
          </button>
        </div>

        {/* ── Table Card ── */}
        <div className="faq-table-container">
          <div className="faq-table-responsive">
            <table className="faq-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Question</th>
                  <th>Answer</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Loading FAQs...
                    </td>
                  </tr>
                ) : faqs.length > 0 ? (
                  faqs.map((faq) => (
                    <tr key={faq.id} className="faq-table-row">
                      <td className="faq-td-id">{faq.id}</td>
                      <td className="faq-td-question">{faq.question}</td>
                      <td className="faq-td-question">{faq.answer}</td>
                      <td className="faq-td-category">{faq.category}</td>

                      <td>
                        <span className={`faq-status-badge ${faq.status.toLowerCase()}`}>
                          {faq.status}
                        </span>
                      </td>

                      <td>
                        <button
                          className="faq-edit-btn"
                          onClick={() => {
                            handleEditFaq();
                            setFaqForEdit(faq);
                          }}
                        >
                          <FiEdit />
                        </button>

                        <button
                          className="faq-del-btn"
                          title="Delete"
                          onClick={() => deleteFaqs(faq)}
                        >
                          <FiTrash2 size={14} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No FAQs Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>

          {/* ── Footer / Pagination ── */}
          <div className="faq-table-footer">
            <div className="faq-pagination">
              <button
                className="faq-page-arrow"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}
              >Previous</button>

              <button className="faq-page-arrow faq-page-arrow-icon"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}>‹</button>

              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`faq-page-num ${currentPage === i + 1 ? 'active' : ''}`}
                  onClick={() => setCurrentPage(i + 1)}
                >{i + 1}</button>
              ))}

              <span className="faq-page-of">of {totalPages}</span>

              <button className="faq-page-arrow faq-page-arrow-icon"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(p => p + 1)}>›</button>

              <button
                className="faq-page-arrow"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(p => p + 1)}
              >Next</button>
            </div>
          </div>
        </div>

        {/* ── Modal ── */}
        <AddQuestionModal
          show={showModal}
          onClose={() => setShowModal(false)}
          onSuccess={() => setShowSuccess(true)}
          loadAllFaqs={() => { viewAllFaqs() }}
          textForEditAdd={textForEditAdd}
          faqForEdit={faqForEdit}
        />

        {/* ── Success Popup ── */}
        <SuccessPopup show={showSuccess} onClose={() => setShowSuccess(false)} />
      </div>
    </AdminMasterLayout>
  );
};

export default Managefaqs;